import { Box } from "di-box";
import { Layer } from "brigada/src/widget/Layer.js";

export class BrigadaBox extends Box {

	/**
	 * @type {function(): ILinker}
	 */
	oneLinker;

	/**
	 * @type {function(): IStorage}
	 */
	oneStorage;

	/**
	 * @type {function(): IRelQuery}
	 */
	newRelQuery;

	Area;
	Btn;
	Frame;
	Form;
	FormField;
	History;
	HistoryAdapter;
	Layers;
	RemoteValidator;
	Request;
	deepKey;

	init() {
		this._setWidgets();
		this._setOpts();
		return this._setPolyfills();
	}

	_setWidgets() {
		const { Area, Btn, Form, FormField, Frame, History, Layers } = this;
		this.oneLinker().setWidgets( {
			Area,
			Btn,
			Form,
			FormField,
			Frame,
			History,
			Layers,
			Layer
		} );
	}

	_setOpts() {
		//const { Form, deepKey, History } = this.oMap;
		this.oneLinker().setOpts( {
			Btn: {
				/** @param {Btn} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.oneRequest = this.oneRequest;
				}
			},
			Form: {
				/** @param {Form} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.oneRequest = this.oneRequest;
					oWidget.newValidator = this.newRemoteValidator;
				}
			},
			FormField: {
				/** @param {FormField} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.cForm = this.Form;
				}
			},
			Area: {
				/** @param {Area} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.oneRequest = this.oneRequest;
				}
			},
			Layers: {
				/** @param {Layers} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.sFrameBlockId = 'Frame';
					oWidget.fnDeepKey = this.deepKey;
					oWidget.sFrameBlockId = 'Frame';
				}
			},
			Frame: {
				/** @param {Frame} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.newXhr = this.newXhr;
					oWidget.oneStorage = this.oneStorage;
				},
				/** @param {Frame} oWidget */
				fnBeforeRun: ( oWidget ) => {
					const oHistory = oWidget._rel()
						.parent()
						.canEmpty()
						.typeOf( this.History )
						.find();
					if( oHistory ) {
						oHistory.registerFrame( oWidget );
					}
				}
			},
			History: {
				/** @param {History} oWidget */
				fnAfterNew: ( oWidget ) => {
					oWidget.aPathParts = [ 'main' ];
					oWidget.oneHistoryAdapter = this.oneHistoryAdapter;
				}
			}
		} );
	}

	_setPolyfills() {

		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/slice
		if ( !Uint8Array.prototype.slice ) {
			Object.defineProperty( Uint8Array.prototype, 'slice', {
				value: function ( begin, end ) {
					return new Uint8Array( Array.prototype.slice.call( this, begin, end ) );
				}
			} );
		}

		const fnBlob = () => {
			const bIsIe = !!window.document.documentMode;
			let bSupported = false;
			try {
				bSupported = new Blob( [ "ä" ] ).size === 2;
			} catch ( e ) {}

			return Promise.resolve(
				( bSupported && !bIsIe )
				||
				import( /* webpackChunkName: "polyfill-Blob" */ 'blob-polyfill' ).then( ( oPolyfill ) => {
					window.Blob = oPolyfill.Blob;
				} )
			);
		};
		const fnFormData = () => {
			return Promise.resolve(
				( typeof FormData !== 'undefined' && FormData.prototype.keys )
				||
				import( /* webpackChunkName: "polyfill-FormData" */ 'formdata-polyfill' )
			);
		};
		return fnBlob().then( () => { return fnFormData(); } )
	}

	/**
	 * @type {function(): Request}
	 */
	oneRequest() {
		return this.one( this.newRequest );
	}

	newRequest() {
		const { Request, deepKey, Frame, Layers } = this;
		const oRequest = new Request();
		oRequest.newRelQuery = this.newRelQuery;
		oRequest.cFrame = Frame;
		oRequest.cLayers = Layers;
		oRequest.fnDeepKey = deepKey;
		return oRequest;
	};

	newRemoteValidator( eForm ) {
		const { RemoteValidator, FormField } = this;
		const oRemoteValidator = new RemoteValidator( eForm );
		oRemoteValidator.newXhr = this.newXhr;
		oRemoteValidator.newRelQuery = this.newRelQuery;
		oRemoteValidator.cFormField = FormField;
		//this._assertUndefProps( oRemoteValidator );
		return oRemoteValidator;
	};

	newXhr() {
		return new XMLHttpRequest();
	}

	oneHistoryAdapter() {
		return this.one( this.newHistoryAdapter );
	}

	newHistoryAdapter() {
		return new this.HistoryAdapter();
	}
}